module.exports = __webpack_public_path__ + "img/dashboard.e58b65c0.png";